const CHART_SETTINGS_VOLUME_MENU_OPTION_OVERLAY = 'Overlay';
const CHART_SETTINGS_VOLUME_MENU_OPTION_SEPARATE = 'Separate';
const CHART_SETTINGS_VOLUME_MENU_OPTION_OFF = 'Off';
const DEFAULT_CHART_SETTINGS_VOLUME_MENU_OPTION = CHART_SETTINGS_VOLUME_MENU_OPTION_OFF;
const CHART_SETTINGS_VOLUME_MENU_OPTIONS_ARRAY = [
  CHART_SETTINGS_VOLUME_MENU_OPTION_OVERLAY,
  CHART_SETTINGS_VOLUME_MENU_OPTION_SEPARATE,
  CHART_SETTINGS_VOLUME_MENU_OPTION_OFF
];

export {
  CHART_SETTINGS_VOLUME_MENU_OPTION_OVERLAY,
  CHART_SETTINGS_VOLUME_MENU_OPTION_SEPARATE,
  CHART_SETTINGS_VOLUME_MENU_OPTION_OFF,
  DEFAULT_CHART_SETTINGS_VOLUME_MENU_OPTION,
  CHART_SETTINGS_VOLUME_MENU_OPTIONS_ARRAY
};
